<template>
  <div class="content_page">
    <Tabbar :title="$t('withdrawAccount.bindThirdPartyTitle', ['IMPS'])"></Tabbar>
    <WithdrawStepper v-if="fromBasicLevel" />
    <div class="content_area">
      <Tip :content="$t('withdrawAccount.bindNote')" />
      <div class="content_item">
        <CommonFormItem :label="$t('account.account')" required>
          <CommonInput v-model="bankAccount" theme="white" type="text" />
        </CommonFormItem>
      </div>
      <div class="content_item">
        <CommonFormItem :label="$t('withdrawAccount.accountName')" required>
          <CommonInput v-model="bankAccountName" theme="white" type="text" />
        </CommonFormItem>
      </div>
      <div class="content_item">
        <CommonFormItem :label="$t('common.phone')" required>
          <CommonInput v-model="phone" theme="white" type="text" :disabled="!!$store.state.userInfo.phone" />
        </CommonFormItem>
      </div>
      <div class="content_item">
        <CommonFormItem :label="$t('common.email')" required>
          <CommonInput v-model="email" theme="white" type="text" :disabled="!!$store.state.userInfo.email" />
        </CommonFormItem>
      </div>
      <div class="content_item">
        <CommonFormItem :label="$t('withdrawAccount.ifscCode')" required>
          <CommonInput v-model="bankSwift" theme="white" type="text" maxLength="11" />
        </CommonFormItem>
      </div>
      <div class="done_btn_area">
        <CommonBtn class="done_btn" :text="$t('common.done')" :on-click="bindThirdPartyPay" />
      </div>
    </div>
    <PopWindow v-show="popShow" :content="popContent" :btn="popBtn" @closePop="closePop"></PopWindow>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import WithdrawStepper from '@/components/WithdrawStepper.vue'
import { Toast } from 'vant'
import PopWindow from '@/components/PopWindow'
import CommonFormItem from '@/components/CommonFormItem'
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn'
import debounce from 'lodash/debounce'

export default {
  name: 'BindNewIMPS',
  components: {
    Tabbar,
    WithdrawStepper,
    PopWindow,
    CommonFormItem,
    CommonInput,
    CommonBtn
  },
  data() {
    return {
      channel: '',
      withdrawType: undefined,
      isShow: false,
      popShow: false,
      popContent: '',
      popBtn: '',
      bankAccount: '',
      bankAccountName: '',
      phone: '',
      email: '',
      bankSwift: ''
    }
  },
  computed: {
    fromBasicLevel() {
      return this.$route.query.from === 'BasicLevel'
    }
  },
  mounted() {
    if (this.$route.params.account) {
      this.account = this.$route.params.account
    }
    switch (this.$route.name) {
      case 'BindNewIMPS':
        this.channel = 'IMPS'
        this.withdrawType = 16
        break
      default:
        break
    }
  },
  methods: {
    closePop() {
      this.popShow = false
    },
    bindThirdPartyPay: debounce(
      function () {
        if (!this.bankAccount) {
          Toast(this.$t('withdrawAccount.accountEmptyToast'))
          return
        }
        if (!this.bankAccountName) {
          Toast(this.$t('withdrawAccount.accountNameEmptyToast'))
          return
        }
        if (!this.phone) {
          Toast(this.$t('withdrawAccount.phoneEmptyToast'))
          return
        }
        if (!this.email) {
          Toast(this.$t('withdrawAccount.emailEmptyToast'))
          return
        }
        if (!this.bankSwift) {
          Toast(this.$t('withdrawAccount.ifscCodeEmptyToast'))
          return
        }
        if (this.bankSwift.length !== 11) {
          Toast(this.$t('withdrawAccount.ifscCodeLengthToast'))
          return
        }
        const data = {
          bankAccount: this.bankAccount,
          bankAccountName: this.bankAccountName,
          phone: this.phone,
          email: this.email,
          bankSwift: this.bankSwift
        }
        this.$http
          .post(window.serverPath + '/api/account/bindBankCard', data)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              if (this.$route.query.from === 'BasicLevel') {
                this.$router.replace({ name: 'Withdrawal' })
              } else if (this.$route.query.hasOwnProperty('redirect')) {
                this.$router.replace({ name: this.$route.query.redirect })
              } else {
                this.$router.back()
              }
            } else if (res.data.code === '60402') {
              Toast(this.$t('withdrawAccount.bindIMPSRepeatToast'))
            } else if (res.data.code === '40208') {
              // 该银行卡已与其他姓名绑定
              this.popShow = true
              this.popContent = res.data.message
              this.popBtn = 'OK'
            } else {
              Toast(this.$t('basicLevel.failToast'))
            }
          })
          .catch((err) => console.log(err))
      },
      1000,
      { leading: true, trailing: false }
    )
  },
  created() {
    this.phone = this.$store.state.userInfo.phone
    this.email = this.$store.state.userInfo.email
  }
}
</script>

<style scoped>
.content_page {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 0;
}

.content_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.content_area {
  width: 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
}

.content_item {
  width: 100%;
  margin-bottom: 0.12rem;
}

.done_btn_area {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.86rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eeeef7;
  padding: 0.18rem;
  background: #ffffff;
}

.done_btn {
  font-size: 0.16rem !important;
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/BindNewIMPS.vue